import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-finish",
  "use": "icon-finish-usage",
  "viewBox": "0 0 25 24",
  "content": "<symbol viewBox=\"0 0 25 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-finish\">\n<rect x=\"0.600098\" width=\"24\" height=\"24\" rx=\"12\" fill=\"currentColor\" />\n<path d=\"M10.9595 15.0469L7.66254 11.7499C7.52721 11.6146 7.36571 11.5729 7.17804 11.6249C6.99038 11.6769 6.87321 11.7941 6.82654 11.9764C6.77988 12.1587 6.82421 12.3227 6.95954 12.4684L10.9595 16.4684L18.9595 8.46839C19.0532 8.36405 19.0975 8.24422 19.0925 8.10889C19.0875 7.97355 19.0354 7.85639 18.936 7.75739C18.8367 7.65839 18.722 7.60889 18.592 7.60889C18.462 7.60889 18.3449 7.65572 18.2405 7.74939L10.9595 15.0469Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcon/svg/finish.svg
// module id = gDaB
// module chunks = 262